"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduledEmailRecipientDisplayName = exports.getScheduledEmailRecipientEmail = exports.getScheduledEmailRecipientUniqueIdentifier = void 0;
// (C) 2019-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var interfaces_1 = require("../interfaces");
exports.getScheduledEmailRecipientUniqueIdentifier = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? recipient.user.login : recipient.email;
};
exports.getScheduledEmailRecipientEmail = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? recipient.user.email : recipient.email;
};
exports.getScheduledEmailRecipientDisplayName = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? sdk_model_1.userFullName(recipient.user) : recipient.email;
};
//# sourceMappingURL=scheduledMailRecipients.js.map